import Header from "../components/Header";
import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { Helmet } from "react-helmet";

export default function SchoolEnrichmentProgrammes() {
  return (
    <>
      <Helmet>
        <title>
          Public Speaking Training for Schools (Workshop) | Public Speaking
          Academy
        </title>
        <meta
          name="description"
          content="Find out why we are the preferred choice for effective communication excellence and public speaking course for kids in Singapore. Led by top public speaker, Darren Tay."
        />
      </Helmet>

      <section id="breadcrumb" className="bg-[#F5F5FC] py-1">
        <div className="container mx-auto">
          <div className="flex flex-row justify-between mx-3">
            <div>SCHOOL / ENRICHMENT PROGRAM</div>
            <div>
              Home / Corporate / School Training / School/Enrichment Programmes
            </div>
          </div>
        </div>
      </section>

      <section id="block-1" className="mx-3">
        <div class="container mx-auto py-20">
          <div class="flex flex-col lg:flex-row pt-5 space-x-10">
            <div class="w-full lg:w-2/3">
              <h1 class="font-primary text-2xl font-bold text-primary uppercase">
                Public Speaking Training for Schools & Educational Institutes
                (all levels)
              </h1>
              <h2 class="font-primary text-xl font-bold text-primary uppercase py-5">
                Customised & Tailored Training for Your Students to Grow as
                Confident, Competent, and Creative Communicators
              </h2>
              <div>
                <img
                  className="block mx-auto"
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-1-4.png"
                  alt=""
                />
                <div className="p-5 my-5 bg-orange-200 rounded-2xl ">
                  <svg
                    width="48"
                    height="34"
                    viewBox="0 0 48 34"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M44.0002 33.6666H34.0002L27.3335 20.3333V0.333313H47.3335V20.3333H37.3335L44.0002 33.6666ZM17.3335 33.6666H7.33349L0.666824 20.3333V0.333313H20.6668V20.3333H10.6668L17.3335 33.6666Z"
                      fill="#F17732"
                    />
                  </svg>
                  <h3 class="font-text font-bold text-2xl text-primary py-5">
                    Right now, I would pay $100,000 for 10 percent of the future
                    earnings of any of you, so if you’re interested, see me
                    after class. Now, you can improve your value by 50 percent
                    just by learning communication skills--public speaking. If
                    that’s the case, see me after class and I’ll pay you
                    $150,000.
                  </h3>
                  <p className="mb-10 text-lg text-right">
                    Warren Buffett, 2009
                  </p>
                </div>

                <p class="py-2 font-text text-lg">
                  We believe you are as good as what you communicate. If you are
                  looking for a training programme for your students, teachers,
                  or school to help nurture a confident, competent, and coherent
                  voice, we have got you covered. At Public Speaking Academy, we
                  design and deliver customised school training to introduce
                  your learners to public speaking and communication skills.
                  Whether it is to develop your students’ speaking confidence or
                  to focus on their persuasive precision, we deliver dedicated
                  and relevant communication skills, building on our expertise
                  and experience.
                </p>
                <p class="py-2 font-text text-lg">
                  Public speaking, communication or even persuasion skills are
                  no longer ‘just’ trivial “soft” skills. We want to guide your
                  students through these coveted skill-set in the modern home,
                  workplace, and world.
                </p>

                <h3 class="py-5 font-text text-2xl font-bold italic">
                  So, why the Public Speaking Academy?
                </h3>
                <p class="py-2 font-text text-lg">
                  The process of nurturing public speaking confidence can be a
                  daunting path. With Public Speaking Academy, we will bring you
                  expert and experienced communication training, driven by our
                  passion to help you present your students’ voice to a wider
                  audience. From 2009, and building on our Master Trainer’s
                  experience and methodology, we have been conducting public
                  speaking training for various school-based clients (such as
                  Primary/Secondary schools, Institutes of Higher Learning,
                  etc.) in their goal of nurturing impeccable communicators.
                </p>
                <img
                  className="my-10"
                  src="/images/public-speaking-course-for-adults-public-speaking-courses-for-adults-public-speaking-for-adults-3-3.jpg"
                  alt=""
                />

                <p className="text-lg font-text">
                  With the Public Speaking Academy as your choice for a
                  school-based training provider, you will get:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    <b>World Champion Experience:</b> Our programmes are helmed
                    by our quality and professional training faculty members,
                    each in high demand for expertise, accolades, and experience
                    in public speaking. Our training team is led by our Master
                    Trainer/Founder, Darren Tay, the World Champion of Public
                    Speaking in 2016, leveraging his experience in
                    speaking/training more than 250,000 individuals in effective
                    communication skills to utilise in the classroom, future
                    workplace, and the world.
                  </li>
                  <li className="text-lg font-text">
                    <b>Extensive Experience:</b> Our extensive experience in
                    public speaking stretches from 2009, growing to a total of 3
                    branches around Singapore. We have served SMEs, corporate
                    organisations, training companies, schools, and even
                    start-up incubators in customising public
                    speaking/communication solutions for their unique needs. Our
                    mainstay programme has also served students of various age
                    groups (from primary, secondary, international grades, young
                    teen/adults).
                  </li>
                  <li className="text-lg font-text">
                    <b>Customised Experience:</b> We draw from our extensive
                    syllabus and knowledge base to design a customised learning
                    experience that best fits your goals and budget – be it a
                    keynote, a masterclass, or a full public speaking
                    workshop/boot camp. Whether you are looking at developing
                    general public speaking confidence to specialised
                    communication topics for your students (e.g., interview,
                    speech confidence, impromptu), we will work closely with you
                    to design a programme tailored to your students’ unique
                    learning needs.
                  </li>
                </ul>

                <h3 class="py-5 font-text text-2xl font-bold italic">
                  What Will My Students & School Benefit From?
                </h3>
                <p className="text-lg font-text">
                  While every school/student carries a unique need, we are
                  versatile enough to reach into our knowledge and experience
                  bank to fill a gap you may have. We adopt a reasoned,
                  researched, and relevant approach in designing our programmes
                  that straddle a careful balance between (i) engaging theory
                  sharing (e.g., presentations on technique), and (ii) evaluated
                  practice sessions (e.g., practice presentations with
                  feedback). These are some examples of the programmes we have
                  conducted before:
                </p>
                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    <b>Classroom Confidence:</b> We have designed programmes
                    that focus on building general speech and presentation
                    confidence before an audience - these are public speaking
                    techniques directly applicable to their classroom (e.g.,
                    in-class presentation skills, hosting, interpersonal
                    communication)
                  </li>
                  <li className="text-lg font-text">
                    <b>Leadership Communication Confidence:</b> Our young
                    communicators and students are the future leaders of this
                    world. We have designed school-based training with a focus
                    on leadership communication skills from the perspective of
                    public speaking (e.g., student ambassadors, persuasive
                    speaking, inspirational speaking).
                  </li>
                  <li className="text-lg font-text">
                    <b>Future-Ready Confidence:</b> Our school-based training is
                    not just designed for the present; they prepare the students
                    for the future. We have developed and delivered public
                    speaking programmes that nurtures versatile communicators
                    (e.g., journalism, online delivery, persuasive speaking,
                    argumentation)
                  </li>
                </ul>

                <p class="py-2 font-text text-lg">
                  We have covered a wide variety of topics, which include:
                </p>
                <p className="pt-5 pb-5 text-3xl font-bold text-center">
                  Topics Covered:
                </p>
                <img className="my-5" src="/images/topics-covered.jpg" alt="" />
                <p className="pt-5 pb-5 text-2xl italic font-bold font-primary">
                  Alright, I am in! What Now?
                </p>
                <p className="text-lg font-text">
                  We are excited to begin this journey with you to achieve
                  public speaking success! First, we would love to know more
                  about you and your schools/students’ communication needs -
                  feel free to reach out to us through our Query Form to start
                  the conversation and curate your public speaking training.
                </p>
                <p className="py-3 text-lg font-text">
                  We will be there with you as we design the best-fit programme
                  to develop your students into highly effective public speakers
                  in the classroom, empowered with charisma, influence, and
                  impact!
                </p>
                <p className="py-3 text-lg font-bold font-text">
                  In reaching out to us, it would be helpful to share these
                  preliminary information to help us understand how best to
                  start:
                </p>

                <ul className="p-5 list-disc list-outside">
                  <li className="text-lg font-text">
                    Total number of participants
                  </li>
                  <li className="text-lg font-text">
                    Total duration (estimated)
                  </li>
                  <li className="text-lg font-text">
                    Nature of programme (e.g., 1-day, masterclasses, regular
                    sessions)
                  </li>
                  <li className="text-lg font-text">
                    Total number of trainers required
                  </li>
                  <li className="text-lg font-text">
                    Total duration of training (including time distribution,
                    e.g., 18 hours of instruction, over 2 days or 4 days)
                  </li>
                  <li className="text-lg font-text">
                    Summary of the learning objectives
                  </li>
                  <li className="text-lg font-text">
                    Preferred training venue (at one of our learning centres or
                    on-site)
                  </li>
                  <li className="text-lg font-text">
                    Estimated budget for the assignment
                  </li>
                </ul>
                <p className="py-3 text-lg font-text">
                  We look forward to collaborating with you in designing a
                  public speaking school-based training suited to your students’
                  needs!
                </p>
              </div>

              <div className="bg-slate-50 p-2 md:p-10 ">
                <div className=" mb-10">
                  <h1 className="divider text-primary font-primary font-bold uppercase text-2xl md:text-3xl">
                    END OF COURSE DETAILS
                  </h1>
                  <h1 className="text-slate-500 font-primary font-bold text-center text-xl md:text-2xl">
                    Quick Tips
                  </h1>
                </div>

                <div
                  tabIndex={0}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧒 How to Help My Students Speak More Confidently
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Building speaking confidence in kids starts with a safe
                      space and the right encouragement.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Praise effort, not just performance
                      </p>
                      <p className="font-text">
                        Celebrate the act of speaking up, even if it’s
                        imperfect. E.g. “I see progress! Progress over
                        perfection, ok?”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Practice through play
                      </p>
                      <p className="font-text">
                        Role-play, storytelling, or pretend news reporting makes
                        speaking fun.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Let them lead conversations
                      </p>
                      <p className="font-text">
                        Encourage your child to initiate and order food, greet
                        guests, or ask questions in public.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Set small speaking goals
                      </p>
                      <p className="font-text">
                        Start with a short sentence, then a short personal
                        recount, then a presentation.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Enroll in a supportive program
                      </p>
                      <p className="font-text">
                        Group classes designed for kids can provide coaching and
                        peer encouragement.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={1}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎤 How to Teach Kids Public Speaking
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Teaching public speaking to kids is all about keeping it
                      light, structured, and encouraging.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Teach structure
                      </p>
                      <p className="font-text">
                        Help them organize thoughts into beginning, middle, and
                        end (or Past, Present, Future).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Make it interactive
                      </p>
                      <p className="font-text">
                        Games like tongue twisters, show-and-tell, or impromptu
                        topics build fluency.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Encourage expression
                      </p>
                      <p className="font-text">
                        Let them use gestures, tone, and facial expressions to
                        bring words to life.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Normalize mistakes
                      </p>
                      <p className="font-text">
                        Laugh off stumbles—it builds resilience. Be kind to
                        yourself as well. Reinforce “Progress Over Perfection”
                        mindset.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Model good speaking
                      </p>
                      <p className="font-text">
                        Let kids see you speaking clearly and confidently too.
                        You may show them videos of good speakers as role models
                        as well.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={2}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    📚 Best Public Speaking Class for Children Singapore
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Looking for a solid program for kids in Singapore? Here’s
                      what to look for:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Age-appropriate curriculum
                      </p>
                      <p className="font-text">
                        Make sure the content fits your child’s developmental
                        level.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Focus on confidence-building
                      </p>
                      <p className="font-text">
                        Beyond skills, the best programs grow self-belief that
                        they can apply the same techniques outside of the
                        training class.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Curriculum designed by public speaking practitioners
                      </p>
                      <p className="font-text">
                        Training approach and content designed by speakers who
                        have walked the journey will be more effective. E.g. Our
                        kids syllabi are designed by 2016 Public Speaking World
                        Champion Darren Tay with 20 years of experience.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Regular stage time
                      </p>
                      <p className="font-text">
                        Opportunities to present, perform, or compete are
                        essential.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Passionate instructors
                      </p>
                      <p className="font-text">
                        Look for coaches who specialize in working with young
                        budding speakers.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={3}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    👪 Is Public Speaking Good for Kids?
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Yes—public speaking is one of the most valuable life
                      skills a child can build.
                    </p>
                    <p className="py-1">Here’s why:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Builds confidence
                      </p>
                      <p className="font-text">
                        Kids learn to speak up, reduce fear of rejection/
                        objection, even in unfamiliar settings.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Improves communication
                      </p>
                      <p className="font-text">
                        They become better listeners and more thoughtful
                        speakers.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Sharpens thinking
                      </p>
                      <p className="font-text">
                        Organizing ideas and expressing opinions boosts critical
                        thinking.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Encourages leadership
                      </p>
                      <p className="font-text">
                        Strong speakers often become natural leaders in school
                        and beyond.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Prepares them for interviews and exams
                      </p>
                      <p className="font-text">
                        Verbal communication is a key part of academic/ future
                        career success.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  tabIndex={4}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎓 DSA Interview Tips for Children
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      The Direct School Admission (DSA) interview in Singapore
                      is a key opportunity for your child to stand out.
                    </p>
                    <p className="py-1">Here’s how to help them succeed:</p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Understand the school’s values
                      </p>
                      <p className="font-text">
                        Help your child learn what the school is looking for in
                        applicants, through website and social media posts.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Rehearse common questions
                      </p>
                      <p className="font-text">
                        Practice “Tell me about yourself” or “Why this school?”
                        in mock interviews.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Use real and preferably native examples
                      </p>
                      <p className="font-text">
                        Encourage them to back up strengths with specific
                        stories or experiences, especially personal anecdotes
                        that lends authenticity.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Practice eye contact and posture
                      </p>
                      <p className="font-text">
                        Simple things like sitting up and making eye contact go
                        a long way. Consider expressive gestures, but not
                        exaggerated ones.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Manage nerves with breathing
                      </p>
                      <p className="font-text">
                        Slow breaths before the interview can calm their body
                        and mind.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={5}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🧒 Confidence-Building Tips for Kids in Public Speaking
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Helping children speak with confidence sets them up for
                      life success.
                    </p>
                    <p className="py-1">
                      Here’s how to build that confidence step by step:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Start with small wins
                      </p>
                      <p className="font-text">
                        Let them share a story or joke at dinner. Engage in a
                        conversational back-&-forth to sustain their interest in
                        speaking. Celebrate progress, not perfection.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Create safe speaking spaces
                      </p>
                      <p className="font-text">
                        Encourage low-pressure opportunities like family games
                        or school events.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Role-model bravery
                      </p>
                      <p className="font-text">
                        Show them that it’s okay to be nervous—and that speaking
                        up is still worth it.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Focus on body language
                      </p>
                      <p className="font-text">
                        Teach them to stand tall (chest outwards), make
                        sustained eye contact, and smile.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Enroll in supportive programs/ courses
                      </p>
                      <p className="font-text">
                        Regular practice with encouraging peers and trainers
                        builds skill and courage.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={6}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    📚 Storytelling Activities for Children
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Storytelling boosts imagination, expression, and
                      communication skills.
                    </p>
                    <p className="py-1">
                      Try these fun ways to help your child grow as a
                      storyteller:
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Story cubes or picture cards
                      </p>
                      <p className="font-text">
                        Let them build a story using random images or prompts.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. “Pass the story” game
                      </p>
                      <p className="font-text">
                        Each person adds a sentence—fun and spontaneous!
                        Starting from “He is bald.”, to “He is bald, thin, and
                        wears a shirt full of holes.”
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Daily highlights
                      </p>
                      <p className="font-text">
                        Ask them to share the best part of their day like a
                        mini-story (Who was involved, What happened, How they
                        felt about it).
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Puppet shows or role play
                      </p>
                      <p className="font-text">
                        Using toys or costumes adds creativity and boosts
                        confidence.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Public storytelling time
                      </p>
                      <p className="font-text">
                        Create moments for them to share with others—at home,
                        school, or a training camp.
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  tabIndex={8}
                  className="border collapse collapse-arrow border-gray-200 rounded-box bg-white"
                >
                  <div className="text-xl font-medium collapse-title text-btnColor">
                    🎤 How to Prepare Kids for Show-and-Tell
                  </div>
                  <div className="collapse-content">
                    <p className="p-1">
                      Show-and-tell is a great way to help kids practice
                      speaking in front of others with confidence and clarity.
                    </p>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        1. Help them choose something meaningful
                      </p>
                      <p className="font-text">
                        Pick an item they’re excited to talk about (have spent
                        considerable amount of time on)—it makes speaking
                        easier.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        2. Plan a simple structure
                      </p>
                      <p className="font-text">
                        Guide them to share:
                        <ul>
                          <li>• What the item is</li>
                          <li>
                            • Why they chose it - A short story or fact about it
                          </li>
                          <li>
                            • How the item came about or how it adds value (e.g.
                            water bottle helps to keep them hydrated)
                          </li>
                        </ul>
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        3. Practice out loud
                      </p>
                      <p className="font-text">
                        Let them rehearse at home in front of family or even a
                        stuffed toy audience.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        4. Encourage expressive speaking
                      </p>
                      <p className="font-text">
                        Teach them to smile, make sustained eye contact, and
                        speak clearly—even for just 30 seconds.
                      </p>
                    </div>
                    <div className="py-1">
                      <p className="font-bold font-primary">
                        5. Celebrate effort, not just performance
                      </p>
                      <p className="font-text">
                        Praise their courage for standing up, even if they
                        forget something – seek progress, not perfection
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="hidden lg:inline w-1/3 px-5 pt-5 mb-10 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
